import React, {Fragment} from "react";
import {connect} from "react-redux";
import {updatePage} from "../../actions/page";
import {Button, Col, Pagination, Row, Space, Table, Tag, Tooltip} from "antd";
import {Link} from "react-router-dom";
import {DateFormat} from "../shared/DateFormat";
import {StatusIndicator} from "../shared/Status";
import {displayErrors, normalizeEnum} from "../../libs/utils";
import {EyeOutlined, FilterOutlined} from "@ant-design/icons";
import {DEFAULT_PER_PAGE} from "../../config";
import {adminLoadCompanies} from "../../actions/accounts";
import UndoOutlined from "@ant-design/icons/lib/icons/UndoOutlined";
import CompaniesTableFilter from "./CompaniesTableFilter";

class CompaniesTable extends React.Component {
    state = {
        companies: [],
        loadingCompanies: false,
        pagination: { current: 1, pageSize: DEFAULT_PER_PAGE, total: 0, showSizeChanger: true },
        filters: [],
        showFiltersModal: false,
    };

    componentDidMount() {
        this.props.updatePage('Companies');
        this.adminLoadCompanies();
    }

    adminLoadCompanies(page = null, per_page = null) {
        if(page == null) {
            page = this.state.pagination.current;
            per_page = this.state.pagination.pageSize;
        }

        this.setState({ loadingCompanies: true });

        this.props.adminLoadCompanies(page, per_page, this.state.filters, (res) => {
            window.scrollTo(0, 0);

            this.setState({ companies: res.data.data, loadingCompanies: false,
                pagination: { current: res.data.page, pageSize: res.data.per_page, total: res.data.total, showSizeChanger: true }});
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loadingCompanies: false });
                displayErrors(err.response.data);
            }
        });
    }

    onTableChange(pagination) {
        this.adminLoadCompanies(pagination.current, pagination.pageSize);
    }


    clearFilters() {
        this.setState({ filters: [] }, () => this.adminLoadCompanies());
    }

    setFilter(filter) {
        let filters = this.state.filters.filter(f => f.key !== filter.key);
        filters.push(filter);

        this.setState({ filters }, () => this.adminLoadCompanies());
    }

    removeFilter(item) {
        let filters = this.state.filters.filter(filter => filter.key !== item.key);
        this.setState({ filters }, () => this.adminLoadCompanies());
    }

    showFilters() {
        return this.state.filters.map((filter, i) => {
            let value;

            if (typeof filter.value === 'boolean') {
                if (filter.value) {
                    value = 'Yes';
                } else {
                    value = 'No';
                }
            } else {
                if (filter.visible !== null) {
                    value = filter.visible;
                } else {
                    value = normalizeEnum(filter.value);
                }
            }

            return <Tag key={i} closable onClose={() => this.removeFilter(filter)}>{filter.name}: {value}</Tag>;
        });
    }

    render() {
        const columns = [
            { title: 'ID', dataIndex: 'id', render: (item, record) => <Link to={'/accounts/companies/' + record.guid}>{item}</Link> },
            { title: 'Name', dataIndex: 'name', render: (item, record) => <Link to={'/accounts/companies/' + record.guid}>{item}</Link> },
            { title: 'Owner', dataIndex: 'owner', render: (item) => <Link to={'/accounts/users/' + item.guid}>{item.first_name + ' ' + item.last_name}</Link> },
            { title: 'Status', dataIndex: 'status', render: (item) => <StatusIndicator status={item} el='badge' /> },
            { title: 'Created', dataIndex: 'date_created', render: (item) => <DateFormat value={item} /> },
            { title: '', align: 'right', render: (item, record) => <Link to={'/accounts/companies/' + record.guid}><Button size='small' icon={<EyeOutlined />}>View</Button></Link>}
        ];

        return(
            <Fragment>
                <p>{this.showFilters()}</p>
                <Row justify='space-between' style={{marginBottom: '10px'}}>
                    <Col>
                        <Space>
                            <Button size='small' icon={<FilterOutlined />} onClick={() => this.setState({ showFiltersModal: true })}>Filters</Button>
                        </Space>
                    </Col>
                    <Col>
                        <Space>
                            <Tooltip title='Reload' placement='left'><Button type='circle' size='small' icon={<UndoOutlined />} onClick={() => this.adminLoadCompanies()} /></Tooltip>
                            <Pagination onChange={(page, pageSize) => this.adminLoadCompanies(page, pageSize)} size='small' {...this.state.pagination} />
                        </Space>
                    </Col>
                </Row>
                <Table
                    columns={columns}
                    rowKey={(item) => item.guid}
                    dataSource={this.state.companies}
                    loading={this.state.loadingCompanies}
                    pagination={false}
                    footer={() => <Row justify='space-between'>
                        <Col />
                        <Col><Pagination onChange={(page, pageSize) => this.adminLoadCompanies(page, pageSize)} size='small' {...this.state.pagination} /></Col>
                    </Row>}
                />

                <CompaniesTableFilter
                    showModal={this.state.showFiltersModal}
                    closeModal={() => this.setState({ showFiltersModal: false })}
                    onChange={(filter) => this.setFilter(filter) } />
            </Fragment>
        );
    }
}

export default connect(null, { updatePage, adminLoadCompanies })(CompaniesTable);